export default "__VITE_ASSET__18949bcd__"